<template>
<div class="card mb-2">
    <div class="card-header px-2 py-2">
        <span class="label"><b>Current Holds</b></span>
    </div>
    <div class="card-body p-0 px-1">
        <div class="table-responsive-md">
        <table class="table" v-if="Object.keys(studentDetails).length > 0 && studentDetails.holds != 'None'">
            <thead class="thead-dark">
            <tr>
                <th>Hold Type</th>
                <th>Reason</th>
                <th>From Date</th>
                <th>To Date</th>
                <th>Prevents Registration (Y/N)</th>
            </tr>
            </thead>
            <tbody>
                <tr v-for="(hold, key) in getHolds(studentDetails.holds)" :key="'holds-'+key">

		<!-- <template v-if="checkFutureHold(splitHoldInfo(hold).fromDate, splitHoldInfo(hold).toDate)"> -->
                <template>
                    <td>{{ splitHoldInfo(hold).holdType }}</td>
                    <td><div v-html="splitHoldInfo(hold).reason"></div></td>
                    <td>{{ splitHoldInfo(hold).fromDate }}</td>
                    <td>{{ splitHoldInfo(hold).toDate }}</td>
                    <td>{{ splitHoldInfo(hold).preventsRegistration }}</td>
                </template>
                </tr>
            </tbody>
        </table>
        <p v-else>No Holds exist on your record.</p>
        </div>
    </div>
</div>
</template>

<script>
import { mapState } from 'vuex'
import {format } from "date-fns";

export default {
  data() {
    return {
    };
  },
  computed: {
    ...mapState({
        studentDetailsFromStore: state => state.student.details,
    }),
    studentDetails: {
        get(){
          return this.studentDetailsFromStore
        },
        set(newName){
          return newName
        } 
    }
  },
  mounted() {
     
  },
  methods: {
    checkFutureHold(start_date, end_date) {
     return this.isDateInBetween(new Date(), `${start_date.replace(/-/g, "/")}`, end_date.replace(/-/g, "/"));
    },
    getHolds(holdStr) {
      holdStr = holdStr.replace(/\(\d+?\)/g, '')
      let holdsProp = holdStr.split(', ');
      return holdsProp;
    },
    splitHoldInfo(holdStr) {
      let initial = holdStr.replace(/\//,'#$').split('#$')
      let secondInteration = initial[1].split('|');
      let thirdInteration = secondInteration[1].split('->');
      return {
        holdType: initial[0],
        reason: secondInteration[0],
        fromDate: thirdInteration[0],
        toDate: thirdInteration[1],
        preventsRegistration: secondInteration[2]
      }
    }
  }
};
</script>
